import * as React from 'react'
import _ from 'lodash'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { History, Location } from 'history'

interface ScrollToTopProps {
  children: React.ReactNode
  history: History
  location: Location
  match: RouteComponentProps['match']
}

class ScrollToTop extends React.Component<ScrollToTopProps> {
  componentDidUpdate(prevProps: ScrollToTopProps) {
    const openingProfile =
      !_.includes(prevProps.location.pathname, '/profile') &&
      _.includes(this.props.location.pathname, '/profile')

    if (this.props.location !== prevProps.location && openingProfile) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)
